"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.falcorGraph = void 0;

var _falcor = require("falcor");

var _ModelRoot2 = _interopRequireDefault(require("falcor/lib/ModelRoot"));

var _falcorHttpDatasource = _interopRequireDefault(require("falcor-http-datasource"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var CustomSource = /*#__PURE__*/function (_HttpDataSource) {
  _inherits(CustomSource, _HttpDataSource);

  var _super = _createSuper(CustomSource);

  function CustomSource() {
    _classCallCheck(this, CustomSource);

    return _super.apply(this, arguments);
  }

  _createClass(CustomSource, [{
    key: "onBeforeRequest",
    value: function onBeforeRequest(config) {
      if (window.localStorage) {
        var userToken = window.localStorage.getItem('userToken');

        if (userToken) {
          config.headers['Authorization'] = userToken;
        }
      }
    }
  }]);

  return CustomSource;
}(_falcorHttpDatasource["default"]);

function cacheFromStorage() {
  var falcorCache = {}; // if (localStorage && localStorage.getItem('falcorCache')) {
  //   let token = localStorage.getItem('token')
  //   let user = localStorage.getItem('currentUser')
  //   if (token && user) {
  //     falcorCache = JSON.parse(localStorage.getItem('falcorCache'))
  //   }
  // }

  return falcorCache;
}

var chunker = function chunker(values, request) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var _options$placeholder = options.placeholder,
      placeholder = _options$placeholder === void 0 ? "replace_me" : _options$placeholder,
      _options$chunkSize = options.chunkSize,
      chunkSize = _options$chunkSize === void 0 ? 50 : _options$chunkSize;
  var requests = [];

  var _loop = function _loop(n) {
    requests.push(request.map(function (r) {
      return r === placeholder ? values.slice(n, n + chunkSize) : r;
    }));
  };

  for (var n = 0; n < values.length; n += chunkSize) {
    _loop(n);
  }

  return requests.length ? requests : [request];
};

var falcorChunker = function falcorChunker(values, request) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var _options$falcor = options.falcor,
      falcor = _options$falcor === void 0 ? falcorGraph : _options$falcor,
      rest = _objectWithoutProperties(options, ["falcor"]);

  return chunker(values, request, rest).reduce(function (a, c) {
    return a.then(function () {
      return falcor.get(c);
    });
  }, Promise.resolve());
};

var getArgs = function getArgs(args) {
  return args.reduce(function (a, c) {
    if (Array.isArray(c)) {
      a[0].push(c);
    } else {
      a[1] = c;
    }

    return a;
  }, [[], {}]);
};

var falcorChunkerNice = function falcorChunkerNice() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  var _getArgs = getArgs(args),
      _getArgs2 = _slicedToArray(_getArgs, 2),
      requests = _getArgs2[0],
      options = _getArgs2[1];

  var _options$index = options.index,
      index = _options$index === void 0 ? null : _options$index,
      _options$placeholder2 = options.placeholder,
      placeholder = _options$placeholder2 === void 0 ? "replace_me" : _options$placeholder2,
      rest = _objectWithoutProperties(options, ["index", "placeholder"]);

  return requests.reduce(function (a, c) {
    return a.then(function () {
      var values = [],
          found = false;
      var replace = c.map(function (r, i) {
        if (Array.isArray(r) && r.length && !found && (index === null || index === i)) {
          found = true;
          values = r;
          return placeholder;
        }

        return r;
      });
      return falcorChunker(values, replace, _objectSpread(_objectSpread({}, rest), {}, {
        placeholder: placeholder
      }));
    });
  }, Promise.resolve());
}; // let counter = 0;


var MyModelRoot = /*#__PURE__*/function (_ModelRoot) {
  _inherits(MyModelRoot, _ModelRoot);

  var _super2 = _createSuper(MyModelRoot);

  function MyModelRoot() {
    var _this;

    _classCallCheck(this, MyModelRoot);

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    _this = _super2.call.apply(_super2, [this].concat(args));
    _this.listeners = [];
    _this.onChange = _this.onChange.bind(_assertThisInitialized(_this));
    _this.listen = _this.listen.bind(_assertThisInitialized(_this));
    _this.unlisten = _this.unlisten.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(MyModelRoot, [{
    key: "onChange",
    value: function onChange() {
      this.listeners.forEach(function (func) {
        return func();
      });
    }
  }, {
    key: "listen",
    value: function listen(func) {
      if (!this.listeners.includes(func)) {
        this.listeners.push(func);
      }
    }
  }, {
    key: "unlisten",
    value: function unlisten(func) {
      this.listeners = this.listeners.filter(function (f) {
        return f !== func;
      });
    }
  }]);

  return MyModelRoot;
}(_ModelRoot2["default"]);

var MyModel = /*#__PURE__*/function (_Model) {
  _inherits(MyModel, _Model);

  var _super3 = _createSuper(MyModel);

  function MyModel() {
    var _this2;

    _classCallCheck(this, MyModel);

    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    _this2 = _super3.call.apply(_super3, [this].concat(args));
    _this2.modelRoot = _this2._root;
    _this2.onChange = _this2.onChange.bind(_assertThisInitialized(_this2));
    _this2.remove = _this2.remove.bind(_assertThisInitialized(_this2));
    _this2.chunk = _this2.chunk.bind(_assertThisInitialized(_this2));
    return _this2;
  }

  _createClass(MyModel, [{
    key: "onChange",
    value: function onChange(listener, func) {
      this.modelRoot.listen(listener, func);
    }
  }, {
    key: "remove",
    value: function remove(listener) {
      this.modelRoot.unlisten(listener);
    }
  }, {
    key: "chunk",
    value: function chunk() {
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }

      var _getArgs3 = getArgs(args),
          _getArgs4 = _slicedToArray(_getArgs3, 2),
          requests = _getArgs4[0],
          options = _getArgs4[1];

      return falcorChunkerNice.apply(void 0, _toConsumableArray(requests).concat([_objectSpread({
        falcor: this
      }, options)]));
    }
  }]);

  return MyModel;
}(_falcor.Model);

var falcorGraph = function falcorGraph(API_HOST) {
  return new MyModel({
    _root: new MyModelRoot(),
    source: new CustomSource(API_HOST + '/graph', {
      crossDomain: true,
      withCredentials: false,
      timeout: 120000
    }),
    errorSelector: function errorSelector(path, error) {
      console.log('errorSelector', path, error);
      return error;
    },
    cache: cacheFromStorage()
  }).batch();
};

exports.falcorGraph = falcorGraph;